import { trackDashboardCtaClicked } from "analytics";
import { PATHS } from "constants/pathConstants";
import NextMoveCard from ".";
import Translate from "translate/Translate";
import { useNextMoveMemberContext } from "./useNextMoveMemberContext";

const CologuardPersonalizedResourcesNextMoveCard = () => {
  const { hasCompletedCologuardPersonalizedResourcesSurvey, memberNeedsToTalkToNav } =
    useNextMoveMemberContext();

  if (hasCompletedCologuardPersonalizedResourcesSurvey || memberNeedsToTalkToNav) {
    return null;
  }

  return (
    <NextMoveCard
      tag="new"
      title={<Translate text="Get resources specific to your interests" />}
      body={
        <Translate text="There's a lot of health information out there. Some of it is helpful—and some is inaccurate or misleading. Let us know your interests and we'll share trusted resources to help you confidently improve your health." />
      }
      link={{
        onClick: () => {
          trackDashboardCtaClicked({
            workflow: "learning_resources",
            ctaLocation: "next_move_card",
            ctaId: "learning_resources"
          });
        },
        text: "Take this 2-question survey to get connected with resources",
        url: PATHS.COLOGUARD_PERSONALIZED_RESOURCES_SURVEY
      }}
    />
  );
};

export default CologuardPersonalizedResourcesNextMoveCard;
